import API from './config'

export const IgpmLocalAPI = {
    async getIGPMMonth(month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/igpm_local/getIGPMMonth', { month: month, year: year }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async saveIGPMMonth(obj) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/igpm_local/saveIGPMMonth', obj, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}
